import { WhereFilterOp } from "firebase/firestore";
import useFirestore from "shared/hooks/useFirestore";
import { useState } from "react";

interface sql{
    field:string,
    operator:WhereFilterOp,
    data:string|null
}

const useDuplicateCheck = (table:string, query:sql, setIsDuplicated:React.Dispatch<React.SetStateAction<boolean>>) => {
    const { readFirestoreWithQuery } = useFirestore();
    const [canUse, setCanUse] = useState(false);
    const [isOpenCanUseModal, setIsOpenCanUseModal] = useState(false);
    const [isOpenDuplicatedModal, setIsOpenDuplicatedModal] = useState(false);

    const onDuplicateCheckClick = async() =>{
        await readFirestoreWithQuery(table, query).then(res =>{
            if(!res.empty){
                setIsDuplicated(true);
                setCanUse(false);
                setIsOpenCanUseModal(false);
                setIsOpenDuplicatedModal(true);
            }else{
                setIsDuplicated(false);
                setCanUse(true);
                setIsOpenCanUseModal(true);
                setIsOpenDuplicatedModal(false);
            }
        });
    }

    return {isOpenCanUseModal, setIsOpenCanUseModal, isOpenDuplicatedModal, setIsOpenDuplicatedModal, canUse, onDuplicateCheckClick};
}

export default useDuplicateCheck;